'use client'
import { useEffect, useRef } from 'react'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import isBrowser from '../../utils/isBrowser'

export const TWENTY_FIVE = 25
export const FIFTY = 50
export const SEVENTY_FIVE = 75
export const HUNDRED = 100

export const useScrollEventTracker = (slug: string) => {
  const scrollTwentyFive = useRef(false)
  const scrollFifty = useRef(false)
  const scrollSeventyFive = useRef(false)
  const scrollHundred = useRef(false)

  useEffect(() => {
    scrollTwentyFive.current = false
    scrollFifty.current = false
    scrollSeventyFive.current = false
    scrollHundred.current = false
  }, [slug])

  const handleScroll = () => {
    const currentScrollPercentage = computeScrollPercentage()
    if (currentScrollPercentage >= TWENTY_FIVE && !scrollTwentyFive.current) {
      scrollTwentyFive.current = true
      trackEvent(TELEMETRY_EVENT_NAMES.PAGE_SCROLL, getProperties(TWENTY_FIVE))
    } else if (currentScrollPercentage >= FIFTY && !scrollFifty.current) {
      scrollFifty.current = true
      trackEvent(TELEMETRY_EVENT_NAMES.PAGE_SCROLL, getProperties(FIFTY))
    } else if (currentScrollPercentage >= SEVENTY_FIVE && !scrollSeventyFive.current) {
      scrollSeventyFive.current = true
      trackEvent(TELEMETRY_EVENT_NAMES.PAGE_SCROLL, getProperties(SEVENTY_FIVE))
    } else if (currentScrollPercentage == HUNDRED && !scrollHundred.current) {
      scrollHundred.current = true
      trackEvent(TELEMETRY_EVENT_NAMES.PAGE_SCROLL, getProperties(HUNDRED))
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
}

export const getProperties = (value: number) => {
  return {
    scrollPercentage: value,
  }
}

export const computeScrollPercentage = () => {
  if (!isBrowser()) return null
  const scrollTop = window.scrollY
  const docHeight = document.body.scrollHeight
  return Math.round((scrollTop / (docHeight - window.innerHeight)) * 100)
}
